module.exports = __webpack_public_path__ + "img/partner18.051c5962.png";